(() => {
  const matched = location.pathname.match(/\/policies\/(terms-of-service|privacy-policy|legal-notice|contact-information)\/?$/);
  if (!matched) return;
  const main = document.querySelector('#MainContent');
  const native = main?.querySelector('.shopify-policy__container');
  const source = native?.querySelector('.shopify-policy__body .rte') || native?.querySelector('.shopify-policy__body');
  if (!main || !native || !source || main.querySelector('.en-legal')) return;
  const locale = (document.documentElement.lang || 'en').toLowerCase();
  const az = locale.startsWith('az');
  const localizedUi = {
  "fr": {
    "eyebrow": "EURONAVIGATE · INFORMATIONS LÉGALES",
    "contact": "Contactez-nous →",
    "onPage": "Sur cette page",
    "overview": "Vue d’ensemble",
    "contactDetails": "Coordonnées de l’entreprise",
    "legalInformation": "Informations légales",
    "support": "Contacter notre équipe d’assistance →",
    "descriptions": {
      "terms-of-service": "Consultez les conditions d’utilisation d’Euronavigate et d’achat sur notre site.",
      "privacy-policy": "Découvrez comment les informations des clients sont traitées et protégées.",
      "legal-notice": "Informations sur les marques, les produits tiers et les références de compatibilité.",
      "contact-information": "Coordonnées de l’entreprise et moyens de contacter Euronavigate."
    }
  },
  "es": {
    "eyebrow": "EURONAVIGATE · INFORMACIÓN LEGAL",
    "contact": "Contáctanos →",
    "onPage": "En esta página",
    "overview": "Resumen",
    "contactDetails": "Datos de contacto de la empresa",
    "legalInformation": "Información legal",
    "support": "Contacta con nuestro equipo de asistencia →",
    "descriptions": {
      "terms-of-service": "Consulta las condiciones de uso de Euronavigate y de compra en nuestro sitio web.",
      "privacy-policy": "Conoce cómo se trata y protege la información de los clientes.",
      "legal-notice": "Información sobre marcas, productos de terceros y referencias de compatibilidad.",
      "contact-information": "Datos de contacto de la empresa y formas de contactar con Euronavigate."
    }
  }
};
  const ui = localizedUi[locale.split('-')[0]];
  const label = (key, en, azText) => ui?.[key] || (az ? azText : en);
  const type = matched[1];
  const metadata = {
    'terms-of-service': {en:'Terms of Service',az:'İstifadə şərtləri',enDescription:'Read the terms governing the use of Euronavigate and purchases on our website.',azDescription:'Euronavigate saytından istifadə və sifariş şərtləri barədə məlumat.'},
    'privacy-policy': {en:'Privacy Policy',az:'Məxfilik siyasəti',enDescription:'Understand how customer information is processed and protected.',azDescription:'Müştəri məlumatlarının necə emal olunduğunu və qorunduğunu öyrənin.'},
    'legal-notice': {en:'Legal Notice',az:'Hüquqi bildiriş',enDescription:'Information about trademarks, third-party products and compatibility references.',azDescription:'Ticarət nişanları, üçüncü tərəf məhsulları və uyğunluq istinadları barədə məlumat.'},
    'contact-information': {en:'Contact Information',az:'Əlaqə məlumatları',enDescription:'Business contact details and ways to reach Euronavigate.',azDescription:'Euronavigate şirkətinin əlaqə məlumatları və müraciət kanalları.'}
  };
  const meta = metadata[type];
  const shell = document.createElement('div');
  shell.className = 'en-legal en-legal--' + type;
  const hero = document.createElement('section');
  hero.className = 'en-legal__hero';
  const intro = document.createElement('div');
  intro.className = 'en-legal__intro';
  const eyebrow = document.createElement('p');
  eyebrow.className = 'en-legal__eyebrow';
  eyebrow.textContent = label('eyebrow', 'EURONAVIGATE · LEGAL INFORMATION', 'EURONAVIGATE · HÜQUQİ MƏLUMAT');
  const heading = document.createElement('h1');
  heading.textContent = ui ? (native.querySelector('.shopify-policy__title h1')?.textContent.trim() || meta.en) : (az ? meta.az : meta.en);
  const summary = document.createElement('p');
  summary.className = 'en-legal__description';
  summary.textContent = ui?.descriptions[type] || (az ? meta.azDescription : meta.enDescription);
  const market = location.pathname.match(/^\/([^/]+)\/policies\//);
  const contact = document.createElement('a');
  contact.className = 'en-legal__contact';
  contact.href = (market ? '/' + market[1] : '') + '/pages/contact-us';
  contact.textContent = label('contact', 'Contact Us →', 'Bizimlə əlaqə →');
  intro.append(eyebrow, heading, summary, contact);
  hero.append(intro);
  const workspace = document.createElement('div');
  workspace.className = 'en-legal__workspace';
  const aside = document.createElement('aside');
  aside.className = 'en-legal__sidebar';
  const asideTitle = document.createElement('p');
  asideTitle.className = 'en-legal__sidebar-title';
  asideTitle.textContent = label('onPage', 'On this page', 'Bu səhifədə');
  const nav = document.createElement('nav');
  nav.className = 'en-legal__nav';
  nav.setAttribute('aria-label',asideTitle.textContent);
  aside.append(asideTitle,nav);
  const contentHost = document.createElement('div');
  contentHost.className = 'en-legal__content';
  const shadow = document.createElement('div');
  shadow.append(...[...source.childNodes].map(node=>node.cloneNode(true)));
  const norm = text => text.replace(/\s+/g,' ').trim();
  const legalText = norm(shadow.textContent);
  const markers = [...shadow.querySelectorAll('h2,h3,h4,strong')].filter(node=>{
    const title = norm(node.textContent);
    if(type === 'terms-of-service') return node.tagName === 'STRONG' && (/^SECTION\s+\d+\b/i.test(title) || /^OVERVIEW$/i.test(title));
    if(type === 'privacy-policy') return /^H[234]$/.test(node.tagName) && title.length>3;
    return false;
  });
  const pieces=[];
  for(let i=markers.length-1;i>=0;i--){
    const marker = markers[i];
    if(!shadow.contains(marker)) continue;
    marker.classList.add('en-legal__source-section-title');
    const range=document.createRange();
    range.setStartBefore(marker);
    range.setEnd(shadow,shadow.childNodes.length);
    const frag=range.extractContents();
    const body=document.createElement('div');
    body.append(frag);
    pieces.unshift({label:norm(marker.textContent),body});
  }
  if(type !== 'contact-information' && shadow.childNodes.length && norm(shadow.textContent)){
    const body=document.createElement('div');
    body.append(...[...shadow.childNodes]);
    pieces.unshift({label:label('overview','Overview','Ümumi məlumat'),body});
  }
  if(type === 'contact-information'){
    const grid=document.createElement('div');
    grid.className='en-legal__contact-grid';
    while(shadow.firstChild) grid.appendChild(shadow.firstChild);
    pieces.push({label:label('contactDetails','Business contact details','Əlaqə məlumatları'),body:grid});
  }
  if(!pieces.length){
    const body=document.createElement('div');
    body.append(...[...source.childNodes].map(node=>node.cloneNode(true)));
    pieces.push({label:label('legalInformation','Legal information','Hüquqi məlumat'),body});
  }
  if(norm(pieces.map(p=>p.body.textContent).join(' '))!==legalText) return;
  const anchors=[];
  pieces.forEach((piece,i)=>{
    const article=document.createElement('section');
    article.className='en-legal__card';
    article.id='en-legal-section-'+i;
    const title=document.createElement('h2');
    title.className='en-legal__card-title';
    title.textContent=piece.label;
    piece.body.classList.add('en-legal__card-body');
    article.append(title,piece.body);
    contentHost.append(article);
    const a=document.createElement('a');
    a.href='#'+article.id;
    a.textContent=piece.label;
    nav.append(a);
    anchors.push({article,link:a});
  });
  const bottom = document.createElement('div');
  bottom.className='en-legal__bottom';
  const bottomLink=document.createElement('a');
  bottomLink.href=contact.href;
  bottomLink.textContent=label('support','Contact our support team →','Müştəri dəstəyi ilə əlaqə →');
  bottom.append(bottomLink);
  contentHost.append(bottom);
  workspace.append(aside,contentHost);
  shell.append(hero,workspace);
  native.before(shell);
  document.body.classList.add('en-legal-active');
  let scheduled=false;
  const update=()=>{
    scheduled=false;
    let active=0;
    anchors.forEach((entry,i)=>{if(entry.article.getBoundingClientRect().top<=195)active=i});
    anchors.forEach((entry,i)=>{
      entry.link.classList.toggle('is-active',i===active);
      if(i===active)entry.link.setAttribute('aria-current','location');
      else entry.link.removeAttribute('aria-current');
    });
  };
  const schedule=()=>{if(scheduled)return;scheduled=true;requestAnimationFrame(update)};
  addEventListener('scroll',schedule,{passive:true});
  addEventListener('resize',schedule);
  update();
})();